<template>
  <highcharts deepCopyOnUpdate :options="chartOptions" ref="chart"></highcharts>
</template>

<script>
export default {
  name: 'barChart',
  props: {
    titleChart: {
      type: String
    },
    categories: {
      type: Array,
      default: () => []
    },
    series: {
      type: Array,
      required: true,
      default: () => []
    },
    prefixLabel: {
      type: String,
      default: '$'
    }
  },
  data() {
    const prefixLabel = this.prefixLabel
    return {
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.titleChart
        },

        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          },
          labels: {
            formatter: function() {
              return prefixLabel + '' + this.value
            }
          }
        },
        tooltip: {
          headerFormat: '<div class="d-flex flex-row justify-content-start"><b>{point.key}</b></div>',
          pointFormat:
            '<div class="d-flex flex-row justify-content-between"><b style="color:{series.color}">' +
            prefixLabel +
            '{point.y}</b></div>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          series: {
            minPointLength: 0
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped></style>
